module.exports = __webpack_public_path__ + "wechat-static/img/pilot.de7f3d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pilot.png
// module id = w73v
// module chunks = 1